import env from 'env-var'

const config = Object.freeze({
  baseURL: env.get('REACT_APP_API_BARCODE').asUrlString(),
  token: env.get('REACT_APP_API_BARCODE_TOKEN').asString()
})

export default config
